import { render, staticRenderFns } from "./SalarySortedTable.vue?vue&type=template&id=4308fa02&scoped=true&"
import script from "./SalarySortedTable.vue?vue&type=script&lang=js&"
export * from "./SalarySortedTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308fa02",
  null
  
)

export default component.exports